module.exports = __webpack_public_path__ + "static/media/logo-b.bbc6cd8a.svg";